import(/* webpackMode: "eager" */ "/vercel/path0/src/app/airports/[airportPage]/page.js")